<template>
    <div v-if="cartPriceInfo" id="cartPriceInfo">
        <div class="item-price-group__border">
          <div class="item-price-group">
              <div class="item-text">{{`Subtotal${hasMarkup ? '*' : ''}${$store.state.cart.containsBestAvailableItem ? '*' : ''}`}}</div>
              <div class="item-text item-text--heavy">{{ $store.state.cart.priceInfo.subTotal.formattedAmount }}</div>
          </div>
          <div class="item-text snap-eligibilty" v-if="cartPriceInfo.ebtSnapSubtotal && showSnapSubtotal">
            {{ cartPriceInfo.ebtSnapSubtotal.formattedAmount }} in SNAP eligible items
          </div>
        </div>
        <div class="item-price-group item-price-group__border" :id="snapHoldId" v-if="cartPriceInfo.ebtSurcharge">
          <b-tooltip
            v-if="cartPriceInfo.ebtSurcharge.message"
            placement="bottom"
            :target="snapTooltipId"
            triggers="hover focus click blur"
            :container="snapHoldId"
          >
            {{ cartPriceInfo.ebtSurcharge.message}}
          </b-tooltip>

          <div class="item-text">
            {{ snapHoldPercent }} weighed item hold
            <span class="fa fa-info-circle tooltip-icon" :id="snapTooltipId" tabindex="0"/>
          </div>

          <div class="item-text item-text--heavy">{{ cartPriceInfo.ebtSurcharge.surchargeAmount.formattedAmount }}</div>
        </div>
        <!-- fees -->
        <div v-for="(fee, index) in $store.state.cart.fees" :key="index" class="item-price-group item-price-group__border">
          <div class="item-text" :class="{ 'item-text--fee-info' : fee.feeDescription }">
            {{ fee.displayName }}
            <span v-if="fee.feeDescription" :id="'target_' + fee.id" tabindex="0" class="fa fa-info-circle tooltip-icon"/>
            <!-- If a title is not provided (or is an empty string), the tooltip will not show. -->
            <b-tooltip
              :target="'target_' + fee.id"
              :title="fee.feeDescription"
              container="cartPriceInfo"
              placement="bottom"
              triggers="hover focus click blur">
            </b-tooltip>
          </div>
          <div class="item-text item-text--heavy" :class="{ 'item-text--red' : !fee.priceInfo.rawTotalPrice.amount }">
            {{ fee.priceInfo.rawTotalPrice.amount ? fee.priceInfo.rawTotalPrice.formattedAmount : 'FREE' }}
          </div>
        </div>
        <div class="item-price-group item-price-group__border" v-if="$store.state.cart.priceInfo.totalDiscounts.amount != 0" @click="showAllSavings = !showAllSavings">
            <div class="item-text">
                Your Savings
                <span class="fa" :class="showAllSavings ? 'fa-chevron-up' : 'fa-chevron-down'" ></span></div>
            <div class="item-text item-text--red">&#8209;{{ $store.state.cart.priceInfo.totalDiscounts.formattedAmount }}</div>
        </div>
        <div v-if="showAllSavings">
          <!-- Order Coupons -->
            <div v-for="(discount, index) in $store.state.cart.priceInfo.savings" v-bind:key="index" class="item-price-group item-price-group__border"
              :class="{ 'item-price-group__border-none' : index < ($store.state.cart.priceInfo.savings.length - 1) }">
                <div class="item-text item-text--red item-text--red-light">{{ discount.displayName }}</div>
                <div class="item-text item-text--red">&#8209;{{ discount.amount.formattedAmount }}</div>
            </div>
        </div>
        <div v-if="orderHasAppliedGiftCard">
            <div v-for="(paymentGroup, index) in appliedGiftCards" v-bind:key="index" class="item-price-group item-price-group__border">
                <div class="item-text">Gift Card <a href="#" v-if="page != 'OrderConfirmation'" @click.prevent="removeGiftCard(paymentGroup.paymentGroupId)" class="system-link">Remove</a></div>
                <div class="item-text item-text--red">&#8209;{{ paymentGroup.amount.formattedAmount }}</div>
            </div>
        </div>
        <div class="item-price-group item-price-group__border" v-if="$store.state.cart.priceInfo.tax">
            <div class="item-text">Est. Tax</div>
            <div class="item-text item-text--heavy">{{ $store.state.cart.priceInfo.tax.formattedAmount }}</div>
        </div>
        <div class="item-price-group item-price-group__border" v-if="$store.state.cart.gratuity && $store.state.cart.curbsideFulfillmentMode === 'delivery'">
            <div class="item-text">Driver Tip</div>
            <div class="item-text item-text--heavy">{{ $store.state.cart.gratuity.formattedAmount }}</div>
        </div>
        <div class="item-price-group item-price-group__est-total">
            <div class="item-text item-text--total">Est. Total</div>
            <div class="item-text item-text--price">{{ $store.state.cart.priceInfo.total.formattedAmount }}</div>
        </div>
        <div class="d-flex total-saved-section"  v-if="showTotalSavingsSection && $store.state.cart.priceInfo.totalDiscounts.amount !== 0">
          <img src="/img/savings-circle.svg">
          <div class="item-text">You Saved</div>
          <div class="item-text item-text--red">{{ $store.state.cart.priceInfo.totalDiscounts.formattedAmount }}</div>
        </div>

        <div class="payment-details-section" v-if="page === 'OrderConfirmation'">
          <h3 class="payment-details-section__header">Payment methods</h3>

          <div class="payment-details-section__payment-methods">
            <div class="item-price-group" v-for="payment in cartPaymentGroups">
              <div class="item-text card-payment-type">{{ formatCardType(payment) }}</div>
              <div class="item-text">{{ payment.amount.formattedAmount }}</div>
            </div>
          </div>

          <div class="payment-details-section__ebt-info" v-if="ebtPaymentInfo.remainingBalance">
            <div class="payment-details-section__ebt-balance">
              EBT SNAP balance: <b>{{ ebtPaymentInfo.remainingBalance.formattedAmount }}</b>
            </div>
            <div class="payment-details-section__ebt-last-updated">
              {{ formatEbtBalanceCheckDate(ebtPaymentInfo.balanceLastUpdated) }}
            </div>
            <div class="payment-details-section__ebt-disclaimer">
              You may receive a partial refund to your EBT or debit card based on final weights and item substitutions.
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { find } from 'lodash';
import checkoutPlaceOrderButton from '../checkout/CheckoutPlaceOrderButton'

export default {
  name: 'CartTotal',
  components: {
    'checkout-place-order-button': checkoutPlaceOrderButton
  },
  props: {
    showSubTotal: Boolean,
    showPersonalShoppersFee: Boolean,
    showSubmitBtn: Boolean,
    showAllSavingsSection: { type: Boolean, default: false },
    showDeliveryFee: Boolean,
    showTaxAmount: Boolean,
    showPriceTotal: Boolean,
    showSubTotalOnCheckout: Boolean,
    showTotalSavingsSection: Boolean,
    submitButtonText: String,
    priceTotalText: String,
    taxTotalText: String,
    gratuityText: String,
    hasMarkup: Boolean,
    /*
     * Added as a way to prevent issues when mounting this component twice, this
     * property is used when generating the id of the EBT weighed item hold lineitem
     * and tooltip container as b-tooltip requires an id that was lost in mobile view.
     */
    placement: { type: String, default: "page" },
  },
  data () {
    return {
      showAllSavings: this.showAllSavingsSection
    }
  },
  computed: {
    page () {
      return this.$router.currentRoute.name
    },
    orderHasAppliedGiftCard () {
      return this.$store.state.cart.paymentGroups.findIndex(function (group) {
        return group.paymentMethod === 'giftCertificate'
      })
    },
    appliedGiftCards () {
      return this.$store.state.cart.paymentGroups.filter(function (group) {
        return group.paymentMethod === 'giftCertificate'
      })
    },
    /* SNAP Related Variables */
    snapHoldId () {
      return `snap-hold-container-id-${this.placement}`;
    },
    snapTooltipId () {
      return `snap-tooltip-container-id-${this.placement}`;
    },
    // This is a placeholder in case the "weighted item hold" percentage
    // starts being returned from the API response.
    snapHoldPercent () {
      return '10%';
    },
    cartPriceInfo () {
      return this.$store.state.cart.priceInfo;
    },
    cartPaymentGroups () {
      return this.$store.state.cart.paymentGroups;
    },
    ebtPaymentInfo () {
      const ebtPayment = this.cartPaymentGroups.filter(payment => payment.paymentMethod === "ebtSnapPaymentGroup")
      return ebtPayment.length ? ebtPayment[0] : {};
    },
    showSnapSubtotal () {
      // Only show SNAP subtotal on the order confirmation page
      // if they checked out using SNAP or pay at pickup
      return (
        this.page !== "OrderConfirmation" ||
        !!find(
          this.cartPaymentGroups,
          (payment) =>
            payment.paymentMethod === "ebtSnapPaymentGroup" ||
            payment.paymentMethod === "payAtPickupPayment"
        )
      );
    },
  },
  methods: {
    removeGiftCard (paymentGroupId) {
      this.$store.dispatch('cart/DELETE_GIFT_CARD', paymentGroupId)
    },
    formatEbtBalanceCheckDate (dateString) {
      return dateString ? `Checked on ${moment(dateString).format('M/D/YY [at] h:mma')}` : "";
    },
    formatCardType (payment) {
      const { paymentMethod, cardType, lastFour } = payment;

      const paymentMapping = {
        'ebtSnapPaymentGroup': 'EBT SNAP',
        'ebtTanfPaymentGroup': 'EBT TANF',
        'giftCertificate': 'Gift card',
        'payAtPickupPayment': "Pay at pickup",
        'creditCard': cardType,
      }

      const paymentType = paymentMapping[paymentMethod] || paymentMethod;
      const cardSuffix = lastFour ? ` ${lastFour}` : '';

      return `${paymentType}${cardSuffix}`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/lib";

.item-price-group {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.item-price-group__border {
  border-bottom: 1px solid $color-divider-light-gray;
  padding-bottom: 8px;
  margin-bottom: 4px;
}

.item-price-group__border-none {
  border-bottom: none;
}

.item-price-group__est-total {
  padding-top: 16px;
  border-top: 1px solid $color-border-standard-gray;
  margin-top: -5px;
}

.item-text {
  color: $color-text-dark;
  font-family: $font-standard-text;
  font-size: 14px;
  line-height: 19px;

  span {
    font-size: 8px;
  }
}

.item-text--fee-info {
  padding-right: 16px;
}

.item-text--total {
  font-size: 18px;
  font-weight: $font-weight-boldish;
  line-height: 24px;
}

.item-text--price {
  font-size: 21px;
  font-weight: $font-weight-bold;
  line-height: 28px;
}

.item-text--heavy {
  font-weight: $font-weight-bold;
}

.item-text--red {
  color: $color-text-red;
  font-weight: $font-weight-bold;

  &-light {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.place-order-btn {
  width: 100%;
  font-size: 14px;
  font-weight: $font-weight-bold;
  line-height: 19px;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
}

.total-saved-section {
    position: relative;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 25px 0 35px;
    width: 100%;
}

.total-saved-section img {
    position: absolute;
    width: 100%;
    max-width: 217px;
    padding: 15px;
}

// SNAP Styling
.snap-eligibilty {
  font-size: 12px;
  padding: 0 0 0 15px;
}

.item-price-group > .item-text > .tooltip-icon {
  font-size: 14px;
  align-self: center;
  color: $color-button-blue;
}

.payment-details-section {
  font-style: normal;
  font-weight: normal;
}

.payment-details-section__header {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  margin: 30px 0 16px;
}

.payment-details-section__payment-methods {
  font-size: 14px;
  line-height: 19px;
  margin: 0 0 15px;
}

.payment-details-section__ebt-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-payment-type {
  text-transform: capitalize;
}

.payment-details-section__ebt-balance {
  font-size: 16px;
  line-height: 20px;
}

.ebt-snap-balance-amount {
  font-weight: bold;
}

.payment-details-section__ebt-last-updated,
.payment-details-section__ebt-disclaimer {
  font-size: 12px;
  line-height: 16px;
  color: #717172;
  text-align: center;
  margin: 0 0 15px;
}

.payment-details-section__ebt-disclaimer {
  max-width: 300px;
}
</style>
<docs>
  The Vue component for the cart total card.

  ```jsx
    submitButtonText: String,
    showSubTotal: Boolean,
    showPersonalShoppersFee: Boolean,
    showSubmitBtn: Boolean,
    showSavingsDropdown: Boolean,
    showPromoCodeInput: Boolean,
    showDesclaimerText: Boolean,
    showAllSavingsSection: Boolean,
    showTotalSavingsSection: Boolean,
    priceTotalText: String,
    taxTotalText: String,
    gratuityText: String

    <cart-total v-bind="cartTotalCardInfo"></cart-total>
  ```
  Creates a cart total component to display the data that needs to be displayed depending on the page that the user is on
</docs>
